/** Fields accepted by POST /artistCampaign/createCampaign */
export function normalizeStartDate(value) {
  const time = new Date(value).getTime();
  return Number.isFinite(time) ? time : Date.now();
}

export function buildCreateCampaignPayload(draft, { stripeSessionId, session = {} } = {}) {
  const artistEmail = (session.email || draft?.artist_email || '').trim();
  const userId = session.userId || draft?.userId || '';

  const payload = {
    track_name: draft?.track_name || '',
    artist_name: draft?.artist_name || '',
    artist_email: artistEmail,
    track_link: draft?.track_link || '',
    spotify_link: draft?.spotify_link || '',
    spotify_uri: draft?.spotify_uri || '',
    track_released: draft?.track_released !== false,
    track_lyrics: Array.isArray(draft?.track_lyrics) ? draft.track_lyrics : [],
    track_genre: Array.isArray(draft?.track_genre) ? draft.track_genre : [],
    budget: draft?.budget,
    start_date: normalizeStartDate(draft?.start_date),
    end_date: draft?.end_date || '',
    campaign_type: draft?.campaign_type || '',
    track_image: draft?.track_image || '',
    spotifyArtistUrl: draft?.spotifyArtistUrl || '',
    userId,
    estimatedStreams: draft?.estimatedStreams,
    stripeSessionId: stripeSessionId || draft?.stripeSessionId || '',
    draftKey: draft?.draftKey || '',
  };

  if (draft?.campaignPriority) {
    payload.campaignPriority = draft.campaignPriority;
  }

  return payload;
}
